import styled from '@emotion/styled';
import React from 'react';
import P2 from '@base/P2/P2';
import { Fonts, mediaQuery, Spacings } from '@styles/index';

interface DangerousP2Props {
  paragraph: string;
  className?: string;
}

const StyledSubtitle = styled(P2)`
  z-index: 2;
  color: var(--color-i-icon-dark-secondary);
  font-size: ${Fonts.SMALL};
  font-weight: ${Fonts.REGULAR};
  margin-top: ${Spacings.SPACING_3B};
  max-width: 702px;
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.ULTRA_SMALL};
  }
  & *::selection {
    color: var(--color-i-all-black);
    background: var(--color-i-icon-light-tertiary);
  }
`;

const DangerousP2: React.FC<DangerousP2Props> = ({ paragraph, className }) => {
  return (
    <StyledSubtitle
      className={className}
      dangerouslySetInnerHTML={{ __html: paragraph }}
    />
  );
};

DangerousP2.displayName = 'DangerousP2';

export default DangerousP2;
